

$( "select.confirm" )
  .change(function () {
    
    var $select = $(this);
    var $form = $(this).closest('form');
    var $checkboxes = $form.find('input[type="checkbox"]');
    var action = $( "select.confirm option:selected" ).val();
    var text =  "¿" + $( "select.confirm option:selected" ).text() + "?";

    var checked = $checkboxes.filter(':checked').length;

    if(checked < 1)
    	{
    		swal("Debe seleccionar al menos una casilla.");
    		return false;
    	}

    var permanent = "";

    if ($( "select.confirm option:selected" ).attr('data-permanent'))
    	permanent = "Esta acción no se puede deshacer.";


    swal({      
      title: text,
      text: checked + " seleccionado(s). " + permanent,
      icon: "warning",
      buttons: ["Cancelar", "Confirmar"],
      dangerMode: true
    })
    .then(function(result) {
      
      if (result) {
      	
      	show_loading();
      	$form.submit();


      } else {

      	hide_loading();
      	$( "select.confirm" ).val("");
        return false;
        
      }
    });

    
  });
